import { useQuery } from '@tanstack/react-query';
import { BillingPlanFeature, useBillingEnabledFeatures, useEnabledFeature } from 'resources/Organization/Features';

import { serviceTypesApi } from 'components/CustomerIntakeSettings/serviceTypesApi';

export const customerIntakeFlowStates = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  ONBOARDING: 'onboarding',
  LOADING: 'loading',
};

export const useIsIntakeFlowEnabled = () => {
  const { isLoading } = useBillingEnabledFeatures();
  const isEnabledByBilling = useEnabledFeature(BillingPlanFeature.FEATURE_CIF);

  if (isLoading) {
    return customerIntakeFlowStates.LOADING;
  }

  if (isEnabledByBilling) {
    return customerIntakeFlowStates.ENABLED;
  }

  return customerIntakeFlowStates.DISABLED;
};

export const useIntakeFlowVisiblePage = () => {
  const isEnabled = useIsIntakeFlowEnabled();
  const {
    data: hasFinishedOnboarding,
    isLoading: isLoadingOnboarding,
    refetch,
  } = useQuery(['customerIntakeOnboarding'], serviceTypesApi.onboarding);

  if (isEnabled === customerIntakeFlowStates.ENABLED) {
    if (isLoadingOnboarding) {
      return { pageToShow: customerIntakeFlowStates.LOADING, refetch };
    }

    if (!hasFinishedOnboarding) {
      return { pageToShow: customerIntakeFlowStates.ONBOARDING, refetch };
    }
  }

  return { pageToShow: isEnabled, refetch };
};
